import { get } from '@/_helper/storage.jsx';

export enum PaymentType {
    CreditCard = 'creditCard',
    PayPal = 'payPal',
}

export default class PaymentError extends Error {
    protected bookingNumber: string;
    protected paymentType: string;
    protected transactionIdentifier: string | undefined;
    protected spsErrors: Error[] | undefined;

    constructor(message: string, paymentType: PaymentType, transactionIdentifier?: string, spsErrors?: Error[]) {
        super(message);
        this.name = 'PaymentException';
        this.bookingNumber = get('bookingNumber');
        this.paymentType = paymentType;
        this.transactionIdentifier = transactionIdentifier;
        this.spsErrors = spsErrors;
    }

    public toString() {
        let str = `
            ${this.name}: ${this.message}; paymentType: ${this.paymentType}; bookingNumber: ${this.bookingNumber};`;
        if (this.transactionIdentifier) {
            str += ` transactionIdentifier: ${this.transactionIdentifier}`;
        }
        if (Array.isArray(this.spsErrors) && this.spsErrors.length > 0) {
            str += ` spsErrors: ${this.spsErrors.join(', ')}`;
        }
        if (this.stack) {
            str += ` stack: ${this.stack}`;
        }
        return str;
    }
}
